<div *ngIf="displayVariant === 'default'"
  class="error-display-container bg-campfire d-flex align-items-center justify-content-between"
  [class.small]="size === 'small'"
>
  <div class="d-flex column align-items-center">
    <svg-icon
      src="assets/icons/icon-warning.svg"
      class="icon-warning"
      [svgStyle]="{ 'width.rem': 0.75, 'height.rem': 0.75 }"
    ></svg-icon>
    <span class="text-wild-hare uppercase">{{ errorMessage }}</span>
  </div>
  <svg-icon
    *ngIf="isSnackbarError"
    src="assets/icons/icon-close.svg"
    (click)="closeError.emit()"
  ></svg-icon>
</div>
<div *ngIf="displayVariant === 'dialog'"
  class="error-display-container d-flex align-items-center dialog-error-display"
  [class.small]="size === 'small'"
>
  <div class="d-flex column align-items-center">
    <span class="text-campfire font-secondary">{{ errorMessage }}</span>
</div>